import { UseFormRegister, phonePattern } from '@graphcommerce/ecommerce-ui'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import React, { ReactNode, useState } from 'react'
import { StandardTextField } from './TextFieldStyles'

type TelephoneTextInputAdditionalProps = {
  topLabel?: ReactNode
  error?: boolean
  containerClassName?: string
  helperText?: string
  register: UseFormRegister<any>
}

type TelephoneTextInputProps = TelephoneTextInputAdditionalProps & React.HTMLProps<HTMLInputElement>

const TelephoneTextInput = React.forwardRef<HTMLInputElement, TelephoneTextInputProps>(
  (props: TelephoneTextInputProps, ref) => {
    const {
      topLabel,
      className,
      required,
      error = false,
      containerClassName = '',
      children,
      helperText = '',
      register,
      ...otherProps
    } = props

    const placeholder = '555-555-5555'
    const [value, setValue] = useState<string | undefined>()

    const setPhoneValue = (event: any) => {
      const newValue = event?.target?.value.replace(/\D/g, '')

      const valArry = newValue.replaceAll('-', '').trim().split('')

      const isDeleting = value && value?.length > event?.target?.value.length
      if (valArry) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        let val = ''
        const maxIter = valArry.length >= 10 ? 10 : valArry.length
        if (valArry.length >= 3) {
          for (let i = 0; i < maxIter; i++) {
            if (!isDeleting && (i === 2 || i === 5)) {
              val += `${valArry[i]}-`
            } else if (
              (isDeleting && i === 2 && valArry.length > 3) ||
              (i === 5 && valArry.length > 6)
            ) {
              val += `${valArry[i]}-`
            } else {
              val += valArry[i]
            }
          }
          setValue(val)
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          setValue(newValue)
        }
      }
    }

    return (
      <div className={containerClassName}>
        <StandardTextField
          id='telephoneTextField'
          type='text'
          disabled={otherProps.disabled}
          label={<Trans id='Telephone' />}
          variant='outlined'
          error={error}
          color='primary'
          required={required}
          autoComplete='company'
          className='w-[260px] max-w-[260px]'
          size='small'
          onKeyDown={(evt) => {
            if (evt.keyCode < 48 || evt.keyCode > 57) {
              if (evt.key !== 'Backspace' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight')
                evt.preventDefault()
            } else if (value && value.length >= 12) {
              evt.preventDefault()
            }
          }}
          {...register('telephone', {
            value,
            required,
            onChange: (e) => setPhoneValue(e),
            pattern: { value: phonePattern, message: i18n._('Invalid phone number') },
          })}
          value={value}
          sx={{
            width: '260px',
            minWidth: '260px',
          }}
        />
        {/* <input
          className={`rounded-[5px] border-[1px]  bg-transparent px-[10px] py-[4px] text-xl outline-none focus:shadow-none focus:outline-0 ${
            error ? 'border-red text-red' : 'border-tight-black text-black'
          } ${error ? 'placeholder:text-red' : 'placeholder:text-50-grey'} ${className}`}
          placeholder={placeholder}
          required={required}
          onKeyDown={(evt) => {
            if (evt.keyCode < 48 || evt.keyCode > 57) {
              if (evt.key !== 'Backspace' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight')
                evt.preventDefault()
            } else if (value && value.length >= 12) {
              evt.preventDefault()
            }
          }}
          {...register('telephone', {
            value,
            required,
            onChange: (e) => setPhoneValue(e),
            pattern: { value: phonePattern, message: i18n._('Invalid phone number') },
          })}
          value={value}
          {...otherProps}
        /> */}
        {children}
      </div>
    )
  },
)

export { TelephoneTextInput }
